import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

export const languages = [
  {
    code: 'it',
    label: 'Italiano',
    shortLabel: 'IT',
    flagLabel: 'Bandiera italiana',
    flag: (
      <svg viewBox="0 0 24 18" role="img" aria-label="Bandiera italiana" focusable="false">
        <rect width="8" height="18" fill="#009246" />
        <rect x="8" width="8" height="18" fill="#fff" />
        <rect x="16" width="8" height="18" fill="#ce2b37" />
      </svg>
    ),
    avatarFlag: (
      <svg viewBox="0 0 32 32" role="img" aria-label="Bandiera italiana" focusable="false">
        <clipPath id="it-flag-avatar">
          <circle cx="16" cy="16" r="16" />
        </clipPath>
        <g clipPath="url(#it-flag-avatar)">
          <rect width="10.67" height="32" fill="#009246" />
          <rect x="10.67" width="10.67" height="32" fill="#fff" />
          <rect x="21.34" width="10.66" height="32" fill="#ce2b37" />
        </g>
      </svg>
    ),
  },
  {
    code: 'en',
    label: 'English',
    shortLabel: 'EN',
    flagLabel: 'US flag',
    flag: (
      <svg viewBox="0 0 7410 3900" role="img" aria-label="US flag" focusable="false">
        <rect width="7410" height="3900" fill="#b22234" />
        <path
          d="M0 300h7410M0 900h7410M0 1500h7410M0 2100h7410M0 2700h7410M0 3300h7410"
          stroke="#fff"
          strokeWidth="300"
        />
        <rect width="2964" height="2100" fill="#3c3b6e" />
      </svg>
    ),
    avatarFlag: (
      <svg viewBox="0 0 32 32" role="img" aria-label="US flag" focusable="false">
        <clipPath id="us-flag-avatar">
          <circle cx="16" cy="16" r="16" />
        </clipPath>
        <g clipPath="url(#us-flag-avatar)">
          <rect width="32" height="32" fill="#b22234" />
          <path
            d="M0 4h32M0 8h32M0 12h32M0 16h32M0 20h32M0 24h32M0 28h32"
            stroke="#fff"
            strokeWidth="2"
          />
          <rect width="14.5" height="17" fill="#3c3b6e" />
          <g fill="#fff">
            <circle cx="2.5" cy="2.8" r="0.55" />
            <circle cx="6.2" cy="2.8" r="0.55" />
            <circle cx="9.9" cy="2.8" r="0.55" />
            <circle cx="13.6" cy="2.8" r="0.55" />
            <circle cx="4.35" cy="5.6" r="0.55" />
            <circle cx="8.05" cy="5.6" r="0.55" />
            <circle cx="11.75" cy="5.6" r="0.55" />
            <circle cx="2.5" cy="8.4" r="0.55" />
            <circle cx="6.2" cy="8.4" r="0.55" />
            <circle cx="9.9" cy="8.4" r="0.55" />
            <circle cx="13.6" cy="8.4" r="0.55" />
            <circle cx="4.35" cy="11.2" r="0.55" />
            <circle cx="8.05" cy="11.2" r="0.55" />
            <circle cx="11.75" cy="11.2" r="0.55" />
            <circle cx="2.5" cy="14" r="0.55" />
            <circle cx="6.2" cy="14" r="0.55" />
            <circle cx="9.9" cy="14" r="0.55" />
            <circle cx="13.6" cy="14" r="0.55" />
          </g>
        </g>
      </svg>
    ),
  },
];

const translations = {
  it: {
    meta: {
      title: 'Quizify | Produci i tuoi quiz',
    },
    common: {
      back: 'Indietro',
    },
    nav: {
      documentation: 'Documentazione',
      index: 'Indice',
      signIn: 'Accedi',
      dashboard: 'Dashboard',
      calendar: 'Calendario',
      calendarMini: 'C',
      accountSetting: 'Impostazioni Account',
      subjects: 'Archivio',
      subjectsMini: 'A',
      quizWip: 'Quiz',
      quizWipMini: 'Q',
      statistics: 'Statistiche',
      statisticsMini: 'S',
      scannerWip: 'Scanner',
      scannerWipMini: 'S',
      scannerLive: 'Scanner Live',
      scannerLiveMini: 'L',
      siteSettings: 'Impostazioni',
      siteSettingsMini: 'I',
      toolsWip: 'Strumenti',
      toolsWipMini: 'S',
      startQuiz: 'Avvia quiz',
      startQuizMini: 'Q',
      logout: 'Esci',
    },
    calendarPage: {
      title: 'Calendario',
      subtitle: 'Organizza gli archivi e le materie che vuoi studiare nei prossimi giorni.',
      today: 'Oggi',
      month: 'Mese',
      week: 'Settimana',
      day: 'Giorno',
      list: 'Lista',
      archive: 'Archivio',
      subject: 'Materia',
      selectArchive: 'Seleziona archivio',
      selectSubject: 'Seleziona materia',
      selectedSubjectProgress: 'Avanzamento della materia selezionata, distinto per tipo di domanda.',
      selectSubject: 'Seleziona materia',
      eventType: 'Cosa vuoi aggiungere?',
      addEventTitle: 'Aggiungi al calendario',
      addEvent: 'Aggiungi',
      cancel: 'Annulla',
      close: 'Chiudi',
      remove: 'Rimuovi',
      dayEventsTitle: 'Eventi del giorno',
      noArchives: 'Non ci sono archivi disponibili. Crea prima un archivio.',
      noSubjects: 'Questo archivio non contiene materie.',
      noEventsForDay: 'Non ci sono eventi per questo giorno.',
      pastDateBlocked: 'Non puoi aggiungere eventi nei giorni precedenti.',
      archiveBlockedBySubjects: 'Hai già inserito una o più materie di questo archivio in questo giorno. Rimuovile prima di aggiungere l’intero archivio.',
      subjectBlockedByArchive: 'Hai già inserito l’intero archivio in questo giorno. Rimuovilo prima di aggiungere una materia dello stesso archivio.',
      archiveAlreadyAdded: 'Questo archivio è già presente in questo giorno.',
      subjectAlreadyAdded: 'Questa materia è già presente in questo giorno.',
      archiveAlreadyScheduled: 'Questo archivio è già pianificato in un giorno non ancora passato.',
      subjectAlreadyScheduled: 'Questa materia è già pianificata in un giorno non ancora passato.',
      archiveBlockedByActiveSubjects: 'Una o più materie di questo archivio sono già pianificate in un giorno non ancora passato. Rimuovile prima di aggiungere l’intero archivio.',
      subjectBlockedByActiveArchive: 'L’intero archivio è già pianificato in un giorno non ancora passato. Rimuovilo prima di aggiungere una materia dello stesso archivio.',
      moreEvents: (count) => `+${count} eventi`,
      eventsCount: (count) => `${count} eventi`,
      sampleEvents: {
        externalLink: 'Apri Google',
        allDay: 'Evento giornaliero',
        longEvent: 'Evento lungo',
        repeating: 'Evento ricorrente',
        birthday: 'Compleanno',
        meeting: 'Riunione',
      },
    },
    scannerPage: {
      title: 'Scanner',
      subtitle: 'Scatta o carica un’immagine, riconosci il testo e trova rapidamente la domanda corretta nel tuo database.',
      questionsLoaded: (count) => `${count} domande disponibili`,
      takePhoto: 'Scatta foto',
      cameraStarting: 'Apro fotocamera...',
      uploadImage: 'Carica immagine',
      ocrLoading: 'Riconoscimento testo in corso',
      recognizedText: 'Testo riconosciuto e da cercare',
      recognizedPlaceholder: 'Il testo OCR apparirà qui. Puoi modificarlo prima della ricerca.',
      answerSearch: 'Cerca testo nelle risposte',
      answerSearchPlaceholder: 'Scrivi una risposta o una parte di risposta per distinguere domande simili...',
      searchButton: 'Cerca',
      resultsTitle: 'Risultati scanner',
      resultsFound: (count) => `${count} risultati trovati`,
      previous: 'Precedente',
      next: 'Successiva',
      archiveFilter: 'Archivio',
      subjectFilter: 'Materia',
      allArchives: 'Tutti gli archivi',
      allSubjects: 'Tutte le materie',
      searchAnswers: 'Cerca anche nelle risposte',
      questionTypeFilter: 'Tipo di domanda',
      allQuestionTypes: 'Aperte e chiuse',
      onlyClosedQuestions: 'Solo chiuse',
      onlyOpenQuestions: 'Solo aperte',
      addAnswerField: 'Aggiungi un testo risposta',
      removeAnswerField: 'Rimuovi questo testo risposta',
      answerSearchNumber: (number) => `Testo risposta ${number}`,
      additionalAnswerSearchPlaceholder: (number) => `Testo della risposta ${number}...`,
      exactSearch: 'Ricerca precisa',
      similaritySearch: 'Ricerca per somiglianza',
      similaritySearchOffHelp: 'Mostra solo domande che contengono quel testo.',
      similaritySearchOnHelp: 'Mostra anche domande simili al testo cercato.',
      openQuestion: 'Aperta',
      closedQuestion: 'Chiusa',
      exactMatch: 'Precisa',
      currentSearch: 'Ricerca attiva',
      noCurrentSearch: 'Nessun testo selezionato',
      loadingQuestions: 'Caricamento domande...',
      emptySearch: 'Scatta una foto, carica un’immagine oppure inserisci il testo riconosciuto da cercare.',
      noResults: 'Nessun risultato trovato. Prova a correggere il testo o ad abilitare la ricerca nelle risposte.',
      noArchiveName: 'Archivio non assegnato',
      questionWithoutText: 'Domanda senza testo',
      correct: 'Corretta',
      emptyAnswer: 'Risposta vuota',
      noCorrectAnswer: 'Nessuna risposta corretta salvata per questa domanda.',
      showAllAnswers: 'Mostra tutte le risposte',
      hideAnswers: 'Nascondi risposte',
      cameraTitle: 'Scatta una foto',
      capture: 'Usa foto',
      cropTitle: 'Ritaglia immagine',
      cropHelp: 'Seleziona solo la parte con la domanda o il testo utile. Trascina il riquadro e usa gli angoli per ridimensionarlo.',
      useCrop: 'Usa ritaglio',
      useFullImage: 'Usa immagine intera',
      close: 'Chiudi',
      errors: {
        generic: 'Errore durante il caricamento dello scanner.',
        invalidImage: 'Immagine non valida. Carica un file immagine o scatta una nuova foto.',
        emptyText: 'Non è stato riconosciuto testo utile nell’immagine.',
        ocrFailed: 'Errore durante il riconoscimento del testo.',
        cameraDenied: 'Permessi fotocamera negati o fotocamera non disponibile.',
      },
    },
    scannerLivePage: {
      title: 'Scanner Live',
      subtitle: 'Inquadra lo schermo: Quizify riconosce le domande e mantiene visibili le risposte suggerite mentre scorri.',
      archive: 'Archivio',
      subject: 'Materia',
      questionType: 'Tipo di domanda',
      allArchives: 'Tutti gli archivi',
      allSubjects: 'Tutte le materie',
      both: 'Aperte e chiuse',
      closed: 'Chiusa',
      open: 'Aperta',
      questionsAvailable: (count) => `${count} domande disponibili`,
      start: 'Avvia Scanner Live',
      starting: 'Preparazione OCR...',
      stop: 'Stop',
      live: 'Live',
      analyzing: 'Analisi in corso',
      reading: 'Sto leggendo lo schermo...',
      pointCamera: 'Inquadra chiaramente una domanda',
      detected: (count) => `${count} domande tracciate`,
      summary: 'Sessione rilevata',
      noAnswer: 'Nessuna risposta corretta salvata.',
      errors: {
        camera: 'Impossibile usare la fotocamera. Controlla i permessi del browser.',
        ocr: 'Non sono riuscito ad analizzare questo fotogramma. La scansione continua automaticamente.',
      },
    },
    statisticsPage: {
      title: 'Statistiche',
      subtitle: 'Panoramica dello studio per archivio, materie e risultati nel tempo.',
      selectArchive: 'Seleziona archivio',
      noArchives: 'Non ci sono archivi disponibili. Crea prima un archivio.',
      correct: 'Corrette',
      wrong: 'Sbagliate',
      unanswered: 'Non risposte',
      unseen: 'Mai viste',
      total: 'Totale',
      accuracy: 'Accuratezza',
      distributionTitle: 'Distribuzione risposte archivio',
      distributionSubtitle: 'Corrette, sbagliate, non risposte e mai viste sulle domande uniche.',
      subjectDistributionTitle: 'Distribuzione e avanzamento materia',
      subjectDistributionSubtitle: 'Consulta le risposte o il passaggio di studio della materia selezionata.',
      accuracyBySubjectTitle: 'Accuratezza per materia',
      accuracyBySubjectSubtitle: 'Percentuale di corrette sulle domande chiuse risposte.',
      noSubjectAccuracy: 'Non ci sono ancora materie con dati sufficienti.',
      trendTitle: 'Andamento risultati',
      trendSubtitle: 'Accuratezza dei quiz nel tempo.',
      noDistribution: 'Non ci sono ancora domande studiate da mostrare.',
      noTrend: 'Non ci sono ancora quiz completati per disegnare l’andamento.',
      subjectOverviewTitle: 'Panoramica materie',
      subjectOverviewSubtitle: 'Ogni barra mostra lo stato reale delle domande della materia.',
      completionBasedOn: 'Completamento basato su',
      details: 'Dettagli',
      close: 'Chiudi',
      question: 'Domanda',
      seenCount: 'Viste',
      wrongCount: 'Sbagliate',
      correctCount: 'Corrette',
      skippedCount: 'Saltate',
      questionWithoutText: 'Domanda senza testo',
      mostWrongQuestions: 'Domande sbagliate più spesso',
      mostSeenQuestions: 'Domande incontrate più spesso',
      unansweredQuestions: 'Domande viste ma non risposte',
      unseenQuestions: 'Domande mai viste',
      noWrongQuestions: 'Non ci sono ancora domande sbagliate per questa materia.',
      noSeenQuestions: 'Non ci sono ancora domande viste per questa materia.',
      noUnansweredQuestions: 'Non ci sono domande viste e lasciate senza risposta.',
      noUnseenQuestions: 'Non ci sono domande mai viste in questa materia.',
      loadedQuestions: (shown, total) => `${shown}/${total} caricate`,
      loadMore: 'Carica altre',
      loading: 'Caricamento...',
      initialCompletion: 'Completamento iniziale',
      progressiveReview: (pass) => `Ripasso progressivo ${pass}`,
      completedPassesDerived: 'Passaggi completi nell’insieme attuale',
      reviewProgressCount: (completed, total) => `${completed}/${total} domande`,
      reviewNotStarted: 'Nessuna domanda è stata ancora visualizzata.',
      allQuestions: 'Tutte',
      closedQuestions: 'Chiuse',
      openQuestions: 'Aperte',
      subjectAnswerDistribution: 'Risposte materia',
      studyProgressDistribution: 'Avanzamento studio',
      reviewDistribution: (pass) => `Avanzamento ripasso ${pass}`,
      reviewCompleted: 'Completate nel passaggio',
      reviewRemaining: 'Rimanenti nel passaggio',
      sortQuestions: 'Ordina domande',
      sortInsertionAsc: 'Inserimento: dalla prima',
      sortInsertionDesc: 'Inserimento: dall’ultima',
      sortAlphabeticalAsc: 'Domanda: A-Z',
      sortAlphabeticalDesc: 'Domanda: Z-A',
      sortSeenDesc: 'Viste: maggiori prima',
      sortSeenAsc: 'Viste: minori prima',
      sortWrongDesc: 'Sbagliate: maggiori prima',
      sortWrongAsc: 'Sbagliate: minori prima',
      sortCorrectDesc: 'Corrette: maggiori prima',
      sortCorrectAsc: 'Corrette: minori prima',
      sortSkippedDesc: 'Saltate: maggiori prima',
      sortSkippedAsc: 'Saltate: minori prima',
    },
    quizPage: {
      title: 'Quiz',
      subtitle: 'Genera un quiz da un intero archivio oppure limita le materie da includere.',
      selectArchive: 'Seleziona archivio',
      totalQuestions: (count) => `Totale quiz: ${count} domande`,
      availableBySubject: (total, closed, open) => `${total} disponibili (${closed} chiuse, ${open} aperte)`,
      subjectQuestionCount: 'Domande per questa materia',
      subjectOpenQuestionCount: 'Domande aperte per questa materia',
      noArchives: 'Non ci sono archivi disponibili. Crea prima un archivio.',
      noSubjectsInArchive: 'Questo archivio non contiene ancora materie.',
      noQuestionsSelected: 'Seleziona almeno una domanda per avviare il quiz.',
      startGeneratedQuiz: 'Avvia quiz',
      selectSubjectsTitle: 'Seleziona le materie da includere',
      selectSubjectsHelp: 'Scegli le materie dell’archivio che vuoi usare nel quiz e imposta quante domande prendere da ciascuna.',
      selectAllSubjects: 'Seleziona tutte',
      deselectAllSubjects: 'Deseleziona tutte',
      resumeQuizTitle: 'Quiz non concluso',
      resumeQuizText: 'Hai un quiz iniziato e non terminato. Succede se chiudi la pagina, il browser si blocca o il computer si spegne prima della conferma finale.',
      continueQuiz: 'Riprendi quiz',
      startNewQuiz: 'Nuovo quiz',
      close: 'Chiudi',
      resumeQuizLoadError: 'Errore durante il recupero del quiz in corso.',
    },
    home: {
      tagline: 'Crea i tuoi quiz e supera le sfide proposte da corsi o materie scolastiche e universitarie.',
      developmentWarning: (
        <>
          Quizify è un progetto personale ancora in fase di sviluppo.<br />
          Alcune funzionalità potrebbero non essere complete, ma non ti verrà mai chiesto di acquistare nulla.
        </>
      ),
      dashboardDemo: 'Inizia ora',
      githubPrefix: 'STAR',
      githubSuffix: 'SU GITHUB',
    },
    auth: {
      signInTitle: 'Accedi',
      signInSubtitle: 'Accedi per poter usare Quizify.',
      signUpTitle: 'Registrati',
      signUpSubtitle: 'Crea il tuo account Quizify.',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      password: 'Password',
      confirmPassword: 'Conferma password',
      rememberMe: 'Ricordami',
      forgotPassword: 'Password dimenticata?',
      signInButton: 'Accedi',
      signUpButton: 'Registrati',
      agreeTerms: 'Accetto i termini di utilizzo',
      socialPrompt: 'oppure accedi con un altro account',
      noAccount: 'Non hai un account?',
      signUpLink: 'Registrati qui.',
      alreadyHaveAccount: 'Hai già un account?',
      invalidCredentials: 'Credenziali non valide.',
      registrationFailed: 'Registrazione non riuscita. Riprova.',
      registrationDisabledTitle: 'Registrazioni disabilitate',
      registrationDisabledMessage: 'Al momento non è possibile creare nuovi account. Riprova più avanti.',
      responseError: 'Errore di risposta dal server:',
      requestError: 'Errore di richiesta:',
      genericError: 'Errore:',
    },
    language: {
      changeLanguage: 'Cambia lingua',
      currentLanguage: 'Lingua corrente',
    },
    siteSettingsPage: {
      title: 'Impostazioni',
      subtitle: 'Gestisci le funzionalità disponibili pubblicamente sulla piattaforma.',
      registrationTitle: 'Registrazione nuovi utenti',
      registrationEnabledHelp: 'Chiunque può aprire la pagina di registrazione e creare un account.',
      registrationDisabledHelp: 'La pagina resta accessibile, ma il modulo è bloccato e nessun account può essere creato.',
      disabledWarning: 'Disabilitando questa opzione, tutte le nuove registrazioni verranno rifiutate anche dal server.',
      enabled: 'Abilitata',
      disabled: 'Disabilitata',
      save: 'Salva impostazioni',
      saving: 'Salvataggio...',
      saved: 'Impostazioni salvate correttamente.',
      loading: 'Caricamento impostazioni...',
    },
    dashboard: {
      subHeaderTitle: 'Ciao!',
      subHeaderText: 'Aiuto gli studenti a studiare e a creare simulazioni d’esame completamente FREE.',
      title: 'Dashboard Quizify',
      greeting: (name) => `Ciao ${name}, continua dai tuoi quiz.`,
      selectArchive: 'Seleziona archivio',
      manageSubjects: 'Gestisci archivio',
      openCalendar: 'Calendario',
      noArchivesAvailable: 'Nessun archivio disponibile',
      noArchivesText: 'Crea un archivio per visualizzare le statistiche della dashboard.',
      tips: [
        'Il completamento misura le domande a cui hai risposto durante i quiz svolti.',
        'Una materia è pronta per i quiz quando contiene almeno 10 domande.',
      ],
      cards: {
        subjects: 'Materie',
        subjectsNote: 'Materie create da te',
        quizAttempts: 'Quiz svolti',
        quizAttemptsNote: 'Sessioni quiz completate',
        completedQuestions: 'Domande completate',
        unansweredNote: (count) => `${count} ancora da rispondere`,
        unseenQuestions: 'Domande non viste',
        seenNote: (count) => `${count} già viste in quiz`,
        totalQuestions: 'Domande totali',
        totalQuestionsNote: 'Domande create da te',
        averageCompletion: 'Completamento medio',
        averageCompletionNote: 'Media sulle tue materie',
        registeredUsers: 'Utenti registrati',
        newUsersNote: (count) => `${count} nuovi negli ultimi 7 giorni`,
        platformSubjects: 'Materie piattaforma',
        platformSubjectsNote: 'Create da tutti gli utenti',
        platformQuestions: 'Domande piattaforma',
        platformQuestionsNote: 'Totale globale',
      },
      subjectsCompletion: 'Materie e completamento',
      subjectsCompletionSubtitle: 'Progresso basato sulle domande viste e risposte nei quiz svolti.',
      table: {
        subject: 'Materia',
        quizAttempts: 'Quiz svolti',
        questions: 'Domande',
        unseen: 'Non viste',
        completion: 'Completamento',
        lastQuiz: 'Ultimo quiz',
      },
      latestQuizzes: 'Ultimi quiz',
      latestQuizzesSubtitle: 'Le tue ultime sessioni quiz completate o ancora in corso.',
      showMoreRecentQuizzes: (count) => `Mostra ${count} altri quiz`,
      hideRecentQuizzes: 'Nascondi',
      reviewQuiz: 'Rivedi quiz',
      continueQuiz: 'Continua quiz',
      inProgressQuiz: 'In corso',
      noSubjectsTitle: 'Non hai ancora materie',
      noSubjectsText: 'Crea un archivio, poi aggiungi la prima materia e inizia ad aggiungere domande.',
      createSubject: 'Crea materia',
      noQuizzesTitle: 'Nessun quiz svolto',
      noQuizzesText: 'Quando avvii e termini un quiz, lo ritrovi qui.',
      answers: 'risposte',
      studyPlanLabel: 'Piano dal calendario',
      studyPlanDueDate: 'Scadenza',
      studyPlanRemaining: 'Domande rimaste',
      studyPlanDailyTarget: 'Da fare al giorno',
      studyPlanCurrentPace: 'Ritmo attuale',
      studyPlanCompleted: 'Completato',
      studyPlanNoPace: 'Non hai ancora ritmo sufficiente per stimare la fine.',
      studyPlanAhead: (days) => (
        days === 0
          ? 'Se continui così, finisci esattamente in tempo.'
          : `Se continui così, finisci ${days} giorni prima.`
      ),
      studyPlanLate: (days) => `Con questo ritmo finiresti ${days} giorni dopo.`,
      studyPlanSubjects: (subjectsCount, days) => `${subjectsCount} materie pianificate - ${days} giorni disponibili`,
      studyPlanBySubject: 'Da fare per materia',
      studyPlanReviewBySubject: (review) => `Ripasso ${review} per materia`,
      studyPlanSubjectDaily: (answeredToday, count) => `${answeredToday}/${count} oggi`,
      studyPlanSubjectClosedDaily: (answeredToday, count) => `Chiuse ${answeredToday}/${count}`,
      studyPlanSubjectOpenDaily: (answeredToday, count) => `Aperte ${answeredToday}/${count}`,
      studyPlanReviewName: (review) => `Ripasso ${review}`,
      studyPlanReviewAnswers: 'Risposte',
      studyPlanReviewSeen: 'Viste',
      studyPlanSubjectReviewProgress: (answered, viewed, total) => (
        `Risposte ${answered}/${total} · Viste ${viewed}/${total}`
      ),
      studyPlanReviewFinish: (review, days) => (
        days <= 1
          ? `Se continui così, finisci il Ripasso ${review} entro oggi.`
          : `Se continui così, finisci il Ripasso ${review} in ${days} giorni.`
      ),
      studyPlanReviewDailyReached: (done, target) => (
        done > target
          ? `Obiettivo di oggi superato: ${done}/${target}.`
          : `Obiettivo di oggi completato: ${done}/${target}.`
      ),
      studyPlanReviewNoPace: (review) => `Completa qualche domanda per stimare la fine del Ripasso ${review}.`,
      studyPlanMoreSubjects: (count) => `+${count} altre materie`,
      studyPlanShowMoreSubjects: (count) => `Mostra ${count} altre materie`,
      studyPlanHideSubjects: 'Nascondi',
      studyPlanReviewStatus: (review, answered, total) => `Ripasso ${review}: risposte ${answered}/${total}`,
      studyPlanViewStatus: (review, viewed, total) => `Viste ${viewed}/${total}`,
      newUsers: 'Nuovi utenti',
      recentRegistrations: 'Ultime registrazioni.',
      noActivity: 'Nessuna attività',
      noDescription: 'Nessuna descrizione',
      loading: 'Caricamento dashboard...',
      invalidSession: "Sessione non valida. Effettua di nuovo l'accesso.",
      loadError: 'Non riesco a caricare i dati della dashboard.',
    },
    toolsPage: {
      title: 'Strumenti',
      subtitle: 'Utility operative per PDF, archivi e materie.',
      openTool: 'Apri',
      backToTools: 'Torna agli strumenti',
      pdfRepair: {
        title: 'Ripara ricerca PDF',
        subtitle: 'Corregge la codifica quando possibile; altrimenti mantiene le pagine originali e aggiunge testo cercabile.',
        fileLabel: 'PDF da analizzare',
        choosePdf: 'Seleziona un PDF.',
        analyze: 'Ripara ricerca',
        analyzing: 'Analisi...',
        reset: 'Cambia PDF',
        resultTitle: 'Anteprima PDF riparato',
        emptyResult: 'Carica un PDF per preparare l’anteprima ricercabile.',
        mode: 'Estrazione',
        repairMethod: 'Riparazione PDF',
        repairMethods: {
          'native-unicode': 'Nativa',
          'coordinate-text-repair': 'Testo-coordinate',
          'fallback-invisible-layer': 'Layer invisibile',
          'text-only-fallback': 'PDF testuale',
        },
        characters: 'Caratteri',
        questions: 'Domande',
        artifacts: 'Caratteri sporchi',
        readyTitle: 'Pronto per il download',
        reviewNeeded: 'Da verificare',
        cleanResult: 'Nessun problema evidente nel testo riconosciuto.',
        copy: 'Copia testo',
        copied: 'Testo copiato negli appunti.',
        copyError: 'Non riesco a copiare il testo automaticamente.',
        download: 'Scarica PDF',
        openPdf: 'Apri PDF',
        openPdfError: 'Non riesco ad aprire il PDF in una nuova scheda. Usa Scarica PDF.',
        downloading: 'Preparo e scarico...',
        preparingPdf: 'Preparo il PDF...',
        previewUnavailable: 'Anteprima PDF non disponibile.',
        downloaded: 'PDF ricercabile creato mantenendo il documento originale.',
        downloadedWithMethod: (method) => `PDF ricercabile creato con: ${method}.`,
        downloadError: 'Errore durante la creazione del PDF ricercabile.',
        searchLabel: 'Verifica testo riconosciuto',
        searchPlaceholder: 'Cerca una parola o una frase',
        pdfSearchPlaceholder: 'Cerca nel PDF',
        pdfSearchAction: 'Cerca',
        pdfSearching: 'Cerco...',
        pdfSearchMatches: (count) => `${count} occorrenze evidenziate.`,
        pdfSearchPrevious: 'Risultato precedente',
        pdfSearchNext: 'Risultato successivo',
        pdfSearchResultCount: (current, total) => `${current || 0}/${total || 0}`,
        pdfSearchNoResults: '0 risultati',
        pdfPreviewLoading: 'Carico anteprima...',
        pdfPageCount: (current, total) => `Pagina ${current || 1}/${total || '-'}`,
        previewRows: (shown, total) => `Prime ${shown} righe su ${total}.`,
        previewMatches: (shown, total) => `${shown} righe trovate su ${total}.`,
        scrollForMoreRecognizedText: 'Scorri per caricare altre righe.',
        noSearchResults: 'Nessuna riga trovata.',
        candidate: 'Estrazione',
        diagnosticsTitle: 'Dettagli estrazione',
        recognizedTextTitle: 'Testo riconosciuto',
        selected: 'usata',
        error: 'Errore durante la riparazione del PDF.',
      },
      subjectCompare: {
        title: 'Confronta materie',
        subtitle: 'Confronta due materie e mostra domande, risposte e corrette diverse.',
        baseArchive: 'Archivio principale',
        baseSubject: 'Materia principale',
        compareArchive: 'Archivio da confrontare',
        compareSubject: 'Materia da confrontare',
        selectArchive: 'Seleziona archivio',
        selectSubject: 'Seleziona materia',
        chooseSubjects: 'Seleziona due materie diverse.',
        compare: 'Confronta',
        comparing: 'Confronto...',
        resultTitle: 'Differenze trovate',
        emptyResult: 'Seleziona due materie e avvia il confronto.',
        matched: 'Abbinate',
        different: 'Diverse',
        onlyBase: 'Solo principale',
        onlyCompare: 'Solo confronto',
        answers: 'Risposte',
        reasons: {
          type: 'Tipo domanda diverso',
          'correct-answer': 'Risposta corretta diversa',
          answers: 'Opzioni diverse',
        },
        differentQuestionsTitle: (count) => `Risposte diverse (${count})`,
        onlyBaseTitle: (count) => `Solo nella materia principale (${count})`,
        onlyCompareTitle: (count) => `Solo nella materia confrontata (${count})`,
        duplicateWarningsTitle: (count) => `Duplicati da verificare (${count})`,
        duplicateWarning: (baseCount, compareCount, questionText) => `Duplicati diversi: ${baseCount} nella principale, ${compareCount} nella confrontata. ${questionText}`,
        noDifferentQuestions: 'Nessuna differenza nelle domande abbinate.',
        noOnlyBase: 'Nessuna domanda presente solo nella materia principale.',
        noOnlyCompare: 'Nessuna domanda presente solo nella materia confrontata.',
        error: 'Errore durante il confronto delle materie.',
      },
    },
    subjectsPage: {
      archives: 'Archivi',
      archive: 'Archivio',
      addArchive: 'Aggiungi archivio',
      archiveName: 'Nome archivio',
      backToArchives: 'Torna agli archivi',
      noArchives: 'Non ci sono archivi. Aggiungi un nuovo archivio.',
      emptyArchiveAlertPrefix: 'Non hai ancora aggiunto archivi.',
      emptyArchiveAlertAction: 'Aggiungi archivio',
      emptyArchiveAlertSuffix: 'per iniziare.',
      totalSubjects: 'Materie totali',
      emptyAlertPrefix: 'Non hai ancora aggiunto materie.',
      emptyAlertAction: 'Aggiungi materia',
      emptyAlertSuffix: 'per iniziare.',
      addSubject: 'Aggiungi materia',
      subjectName: 'Nome materia',
      add: 'Aggiungi',
      close: 'Chiudi',
      edit: 'Modifica',
      start: 'Avvia',
      abort: 'Annulla',
      yesDelete: 'Sì, elimina',
      deleting: 'Eliminazione...',
      totalQuestions: 'Domande totali',
      closedQuestions: 'Domande chiuse',
      openQuestions: 'Domande aperte',
      missingAnswersLabel: 'Senza risposta corretta',
      missingOpenAnswersLabel: 'Risposte aperte da completare',
      missingAnswersSummary: (closed, open) => {
        if (closed > 0 && open > 0) {
          return `Chiuse/Aperte senza risposta corretta: ${closed}/${open}`;
        }

        if (closed > 0) {
          return `Chiuse senza risposta corretta: ${closed}`;
        }

        return `Aperte senza risposta corretta: ${open}`;
      },
      noQuestionsButtonTitle: 'Nessuna domanda presente',
      missingAnswersButtonTitle: (count) => `${count} domande senza risposta corretta`,
      missingOpenAnswersButtonTitle: (count) => `${count} risposte aperte da completare`,
      noSubjects: 'Non ci sono materie. Aggiungi una nuova materia.',
      settingQuiz: 'Impostazioni quiz',
      numberAllQuestions: 'N. domande',
      timer: 'Timer:',
      timerPlaceholder: 'Ore : Minuti',
      quizType: 'Tipo quiz',
      closed: 'Chiuse',
      open: 'Aperte',
      closedQuestion: 'Chiusa',
      openQuestion: 'Aperta',
      both: 'Chiuse e aperte',
      numberOpenQuestions: 'N. domande aperte',
      availableQuestions: (count) => `${count} disponibili con tipo quiz e filtro attuale`,
      closedQuestionsWillBe: (count) => `${count} domande chiuse nel quiz`,
      availableOpenQuestions: (count) => `${count} domande aperte disponibili con il filtro attuale`,
      questionOrder: 'Ordine domande',
      insertedOrder: 'Ordine inserimento',
      randomOrder: 'Casuali',
      answerOrder: 'Ordine risposte',
      answerInsertedOrder: 'Ordine originale',
      answerRandomOrder: 'Casuali',
      correctAnswerFirst: 'Corretta come prima opzione',
      showKeywords: 'Mostra parole chiave',
      questionFilter: 'Filtro domande',
      onlyUnseenQuestions: 'Solo domande mai viste',
      onlySeenQuestions: 'Solo domande già viste',
      allSeenAndUnseenQuestions: 'Tutte (viste e non viste)',
      progressiveReview: 'Ripasso progressivo',
      automaticOpenAnswers: 'Mostra automaticamente la risposta alle domande aperte',
      filterQuestionCount: (label, count) => `${label} (${count})`,
      addQuestionAnswers: 'Aggiungi domanda e risposte',
      editQuestionAnswers: 'Modifica domanda e risposte',
      question: 'Domanda:',
      questionAnswerType: 'Tipo domanda e risposta:',
      single: 'Singola',
      multiple: 'Multipla',
      correctAnswer: 'Risposta corretta',
      answer: (index) => `Risposta ${index}`,
      questions: 'Domande',
      previewQuestion: 'Visualizza e scorri domande',
      questionPreviewTitle: 'Anteprima domanda',
      questionListPreviewTitle: 'Rivedi lista filtrata',
      emptyQuestionAnswer: 'Risposta vuota',
      noFilteredQuestionsToPreview: 'Nessuna domanda da visualizzare con il filtro attuale.',
      questionAnswers: 'Domanda e risposte',
      importFromPdf: 'Importa da PDF',
      importQuestionsFromPdf: 'Importa domande da PDF',
      importAllFromPdf: 'Importa materie da PDF',
      importAllFromPdfTitle: 'Importazione completa da PDF',
      importAllFromPdfText: 'Carica un PDF per creare automaticamente materie, domande e risposte. La funzione sarà implementata nel prossimo passaggio.',
      ecampusImportText: 'Carica il paniere e-Campus in PDF per creare automaticamente la materia, le domande e le risposte. Prende automaticamente anche le risposte date segnate con un segno sul segnaposto della risposta.',
      mininternoImportText: 'Carica il PDF della banca dati Mininterno per creare automaticamente tutte le materie trovate nel file, con domande, risposte e risposta corretta. Se una domanda richiama un brano, il testo del brano viene collegato alla domanda.',
      importMode: 'Tipo importazione',
      backToAddSubject: 'Torna ad aggiungi',
      questionBankType: 'Tipo paniere',
      ecampusQuestionBank: 'Paniere e-Campus',
      ecampusFullImport: 'Paniere e-Campus',
      mininternoFullImport: 'Concorso Mininterno',
      pdfFile: 'File PDF del paniere',
      fullPdfFile: 'File PDF completo',
      featureComingSoon: 'Funzione non ancora attiva',
      importPdf: 'Importa PDF',
      importing: 'Importazione...',
      importPreloaderTitle: 'Importazione in corso',
      importPreloaderMessage: 'Non chiudere questa pagina e non uscire dalla modale finché l’importazione non è completata.',
      importPreloaderHint: 'Il processo può richiedere qualche minuto se il PDF contiene molte domande o testi lunghi.',
      importReport: 'Report importazione',
      expectedQuestions: (open, closed, total) => `Dichiarate nel PDF: ${open ?? '-'} aperte, ${closed ?? '-'} chiuse${total ? `, ${total} totali` : ''}.`,
      contentQuestionMarkers: (count) => `Domande numerate trovate nel contenuto PDF: ${count ?? 0}.`,
      detectedQuestions: (open, closed, total) => `Rilevate dal parser: ${open ?? 0} aperte, ${closed ?? 0} chiuse, ${total ?? 0} totali.`,
      importedQuestions: (open, closed, total) => `Importate nel database: ${open ?? 0} aperte, ${closed ?? 0} chiuse, ${total ?? 0} totali.`,
      detectedAnsweredQuestions: (summary = {}) => `Nel PDF con risposta: ${summary.closedWithCorrect ?? 0}/${summary.closed ?? 0} chiuse corrette, ${summary.openWithAnswer ?? 0}/${summary.open ?? 0} aperte compilate.`,
      insertedAnsweredQuestions: (summary = {}) => `Inserite nuove: ${summary.closedWithCorrect ?? 0} chiuse con corretta, ${summary.closedWithoutCorrect ?? 0} chiuse senza corretta, ${summary.openWithAnswer ?? 0} aperte con risposta, ${summary.openWithoutAnswer ?? 0} aperte vuote.`,
      updatedAnsweredQuestions: (summary = {}) => `Aggiornate esistenti: ${summary.closedCorrectAnswers ?? 0} risposte chiuse, ${summary.openAnswers ?? 0} risposte aperte.`,
      finalAnsweredQuestions: (summary = {}) => `Stato materia dopo import: ${summary.closedWithCorrect ?? 0}/${summary.closed ?? 0} chiuse con corretta, ${summary.openWithAnswer ?? 0}/${summary.open ?? 0} aperte con risposta.`,
      importedSubjects: (count) => `Materie importate o aggiornate: ${count}.`,
      detectedPassages: (count) => `Brani rilevati: ${count}.`,
      skippedDuplicates: (count) => `Duplicate saltate: ${count}.`,
      updatedDuplicateAnswers: (count) => `Risposte aggiornate su domande già presenti: ${count}.`,
      updatedDuplicateCorrectAnswers: (count) => `Risposte chiuse aggiornate su domande già presenti: ${count}.`,
      updatedDuplicateOpenAnswers: (count) => `Risposte aperte aggiornate su domande già presenti: ${count}.`,
      updatedDuplicateKeywordHints: (count) => `Parole chiave aggiornate su domande già presenti: ${count}.`,
      keywordHintsSavedDuringImport: (created, updated) => `Parole chiave salvate: ${created ?? 0} nuove${updated ? `, ${updated} aggiornate` : ''}.`,
      keywordHintsImportSources: (fromPdf, generated) => `${fromPdf ?? 0} da PDF, ${generated ?? 0} generate automaticamente.`,
      duplicateDetailsTitle: 'Dettaglio duplicati',
      duplicateDetail: (detailOrPdfQuestionNumber, existingQuestionNumber) => {
        const detail = typeof detailOrPdfQuestionNumber === 'object'
          ? detailOrPdfQuestionNumber
          : { pdfQuestionNumber: detailOrPdfQuestionNumber, existingQuestionNumber };
        const subjectPrefix = detail.subjectName ? `Materia: ${detail.subjectName} - ` : '';

        return `${subjectPrefix}Domanda app #${detail.existingQuestionNumber}: duplicata con domanda PDF #${detail.pdfQuestionNumber}.`;
      },
      missingCorrectAnswers: (count) => `Domande chiuse senza risposta corretta: ${count}.`,
      missingOpenAnswers: (count) => `Domande aperte senza risposta: ${count}.`,
      importWarningsTitle: 'Avvisi importazione',
      parserSignalsSummary: (signals = {}) => {
        const otherParts = [
          signals.unnumberedOpenQuestions ? `${signals.unnumberedOpenQuestions} aperte senza numerazione` : '',
          signals.splitQuestionMarkers ? `${signals.splitQuestionMarkers} numeri domanda ricostruiti` : '',
          signals.ambiguousClosedAnswers ? `${signals.ambiguousClosedAnswers} ambigue` : '',
        ].filter(Boolean);

        return otherParts.length ? `Altri segnali: ${otherParts.join(', ')}.` : '';
      },
      keywordHighlightSignalsSummary: (signals = {}) => (
        signals.keywordHintsFromHighlight
          ? `Parole chiave PDF riconosciute: ${signals.keywordHintsFromHighlight} risposte con keyword. Segni usati: ${signals.keywordPdfHighlightMarks || 0} evidenziazioni, ${signals.keywordPdfUnderlineMarks || 0} sottolineature.`
          : ''
      ),
      completeQuestionsWithoutAnswers: 'Completa domande senza risposta',
      completeClosedAnswers: 'Completa risposte chiuse',
      completeOpenQuestionsWithoutAnswers: 'Completa risposte aperte',
      regenerateMissingKeywords: 'Rigenera parole chiave mancanti',
      regenerateMissingKeywordsShort: (count) => `Keyword mancanti (${count})`,
      unsavedKeywordsShort: (count) => `Keyword da salvare (${count})`,
      regeneratingKeywords: 'Rigenero parole chiave...',
      savingKeywords: 'Salvataggio...',
      saveAvailableKeywords: 'Salva disponibili',
      keywordRegenerationSummary: (report = {}) => (
        `Parole chiave aggiornate: ${report.updated || 0}. Già presenti: ${report.skippedExisting || 0}. Escluse manualmente: ${report.skippedDisabled || 0}. Senza suggerimento automatico: ${report.skippedUnavailable || 0}.`
      ),
      keywordSaveSummary: (report = {}) => (
        `Parole chiave salvate: ${report.updated || 0}. Già presenti: ${report.skippedExisting || 0}. Escluse manualmente: ${report.skippedDisabled || 0}. Non disponibili: ${report.skippedUnavailable || 0}.`
      ),
      keywordToolsTitle: 'Parole chiave domande chiuse',
      keywordToolsMissingTitle: (count) => `Senza keyword (${count})`,
      keywordToolsUnsavedTitle: (count) => `Keyword da salvare (${count})`,
      keywordToolsMixedTitle: (missingCount, unsavedCount) => `Keyword da sistemare (${unsavedCount} da salvare, ${missingCount} senza)`,
      keywordToolsMixedShort: (missingCount, unsavedCount) => `Keyword: ${unsavedCount} da salvare, ${missingCount} senza`,
      keywordToolsMissingDescription: (count) => `${count} domande chiuse non hanno una keyword salvata né un suggerimento automatico. Aprile dalla tabella e scrivila manualmente.`,
      keywordToolsUnsavedDescription: (count) => `${count} domande chiuse non hanno una keyword salvata, ma hanno una keyword automatica pronta. Puoi salvarle tutte o mostrarle in tabella.`,
      keywordToolsMixedDescription: (missingCount, unsavedCount) => `${unsavedCount} domande non hanno una keyword salvata, ma hanno una keyword automatica pronta. ${missingCount} non hanno suggerimento automatico: mostrale e scrivila manualmente.`,
      keywordsWithoutSavedHint: (count) => `Domande senza parola chiave salvata: ${count}.`,
      keywordsWithAutomaticHint: (count) => `Con suggerimento automatico disponibile: ${count}.`,
      keywordsActuallyMissing: (count) => `Senza parola chiave effettiva: ${count}.`,
      noMissingEffectiveKeywords: 'Tutte le domande chiuse hanno una parola chiave salvata o automatica.',
      showMissingKeywordQuestions: 'Mostra senza keyword',
      showUnsavedKeywordQuestions: 'Mostra da salvare',
      showKeywordToolQuestions: 'Mostra',
      showAllQuestions: 'Mostra tutte',
      copyKeywordPrompt: 'Copia prompt',
      copyMissingKeywordPrompt: 'Copia prompt mancanti',
      copyUnsavedKeywordPrompt: 'Copia prompt da salvare',
      keywordPromptCopied: 'Prompt copiato negli appunti.',
      keywordPromptCopyError: 'Non riesco a copiare il prompt automaticamente.',
      keywordPromptEmpty: 'Nessuna domanda da copiare.',
      missingKeywordFilterActive: (count) => `Filtro: senza keyword (${count}).`,
      unsavedKeywordFilterActive: (count) => `Filtro: keyword non salvate (${count}).`,
      completeMissingAnswersTitle: 'Completa risposte corrette mancanti',
      completeMissingOpenAnswersTitle: 'Completa risposte aperte',
      completeMissingAnswersText: 'Seleziona la risposta corretta per ogni domanda chiusa. Le domande aperte possono restare senza risposta.',
      completeMissingOpenAnswersText: 'Scrivi la risposta di riferimento per le domande aperte. Puoi lasciarla vuota e passare alla prossima.',
      noAnswersToComplete: 'Non ci sono domande chiuse da completare.',
      noOpenAnswersToComplete: 'Non ci sono risposte aperte da completare.',
      correctAnswersSelected: (completed, total) => `${completed}/${total} completate`,
      openAnswersFilled: (completed, total) => `${completed}/${total} compilate`,
      saveAnswers: 'Salva risposte',
      unsavedCompleteAnswersTitle: 'Ci sono modifiche non salvate',
      unsavedCompleteAnswersText: 'Se chiudi senza salvare perderai tutto il progresso fatto finora. Salva per non perdere le risposte date.',
      saveAndClose: 'Salva e chiudi',
      closeWithoutSaving: 'Chiudi senza salvare',
      keepEditing: 'Annulla',
      editSubject: 'Modifica materia',
      confirmDeletion: 'Conferma eliminazione',
      confirmArchiveDeletion: 'Conferma eliminazione archivio',
      deleteArchiveWarning: (name) => (
        <>
          Stai per eliminare l’archivio <strong>{name}</strong>. Verranno eliminate anche tutte le materie, le domande, le risposte e i dati associati contenuti al suo interno.
        </>
      ),
      deleteArchiveConfirmationLabel: 'Scrivi ELIMINA per confermare',
      deleteArchiveConfirmationPlaceholder: 'ELIMINA',
      deleteSubjectConfirm: (name) => <>Sei sicuro di voler eliminare la materia <strong>{name}</strong>?</>,
      deleteQuestionConfirm: (question) => (
        <>
          Sei sicuro di voler eliminare la domanda qui sotto?<br />
          <strong>{question}</strong>
        </>
      ),
      table: {
        question: 'Domanda',
        answers: 'Risposte',
        correct: 'Corretta',
        actions: 'Azioni',
        search: 'Cerca:',
        lengthMenu: 'Mostra _MENU_ righe',
        info: 'Mostro da _START_ a _END_ di _TOTAL_ domande',
        infoEmpty: 'Nessuna domanda disponibile',
        zeroRecords: 'Nessuna domanda trovata',
        emptyTable: 'Nessuna domanda disponibile',
        paginatePrevious: 'Precedente',
        paginateNext: 'Successiva',
        typeFilterLabel: 'Tipo',
        typeFilterAll: 'Tutte',
        typeFilterClosed: 'Chiuse',
        typeFilterOpen: 'Aperte',
      },
      quizSimulation: 'Simulazione quiz',
      questionProgress: (current, total) => `Domanda ${current} di ${total}`,
      enterYourAnswer: 'Inserisci la tua risposta:',
      timeLeft: 'Tempo rimasto:',
      previous: 'Precedente',
      next: 'Successiva',
      endQuiz: 'Termina quiz',
      endQuizConfirmTitle: 'Terminare il quiz?',
      endQuizConfirmText: 'Sei sicuro di voler terminare il quiz? Dopo la conferma verrà calcolato il risultato.',
      unansweredQuestionsWarning: (count) => (
        count === 1
          ? 'C’è 1 domanda senza risposta.'
          : `Ci sono ${count} domande senza risposta.`
      ),
      confirmEndQuiz: 'Sì, termina quiz',
      goBack: 'Indietro',
      saving: 'Salvataggio...',
      openAnswerPlaceholder: 'Scrivi la tua risposta',
      readPassage: (number) => `Leggi brano n.${number}`,
      passageTitle: (number) => `Brano n.${number}`,
      quizCompletedWithIcon: '🎉 Quiz completato',
      quizCompleted: 'Quiz completato',
      calculatedScore: 'Punteggio calcolato',
      timeSummary: (time) => `Tempo: ${time}`,
      correctAnswersSummary: (count) => `✅ Corrette: ${count}`,
      wrongAnswersSummary: (count) => `❌ Errate: ${count}`,
      openQuestionsSummary: (count) => `📝 Domande aperte: ${count}`,
      mixedQuizOpenNote: 'Le domande a risposta aperta non sono incluse nel punteggio automatico e richiedono una valutazione manuale. Per ogni domanda aperta è disponibile la risposta di riferimento per il confronto.',
      openOnlyQuizNote: 'Questo quiz contiene solo domande a risposta aperta. Le risposte richiedono una valutazione manuale e non è disponibile un punteggio automatico. Per ogni domanda è disponibile la risposta di riferimento per il confronto.',
      reviewQuiz: 'Rivedi quiz',
      result: 'Risultato',
      yourAnswer: 'Tua risposta',
      referenceAnswer: 'Risposta di riferimento / descrizione',
      automaticReferenceAnswer: 'Risposta mostrata automaticamente',
      explanation: 'Spiegazione',
      manualReviewBadge: 'Da valutare manualmente',
      findKeyword: 'Trova parola chiave',
      keywordContext: 'Contesto',
      keywordDifference: 'Differenza',
      keywordLabel: 'Parola chiave',
      keywordPlaceholder: '',
      saveKeyword: 'Salva parola chiave',
      updateKeyword: 'Aggiorna parola chiave',
      regenerateKeyword: 'Rigenera',
      keywordHighlightToggle: 'Evidenzia',
      keywordSaved: 'Parola chiave salvata.',
      keywordSaveError: 'Errore durante il salvataggio della parola chiave.',
      keywordTooltipTitle: 'Formato suggerito',
      keywordTooltipContext: 'Facoltativo: tema vicino alla differenza, utile solo come nota.',
      keywordTooltipDifference: 'Parole, sigle, numeri o frasi che compaiono nella risposta corretta e non nelle alternative sbagliate.',
      keywordTooltipFormat: 'Formato consigliato: Differenza: parola, frase breve. Il rigenera privilegia parentesi, virgolette, sigle, numeri e la differenza con la risposta sbagliata più simile. Se “Evidenzia” è attivo, vengono marcate solo differenze presenti in una sola alternativa.',
      noKeywordFound: 'Nessun suggerimento automatico disponibile. Puoi selezionarlo o scriverlo manualmente.',
      noAnswerGiven: 'Nessuna risposta data',
      noReferenceAnswer: 'Nessuna risposta di riferimento disponibile.',
      validation: {
        noCorrectAnswer: 'Errore: nessuna risposta corretta selezionata',
        closedNeedsTwoAnswers: 'Per le domande chiuse ci devono essere almeno due risposte.',
        selectCorrectAnswer: 'Devi selezionare almeno una risposta corretta.',
        addQuestionSuccess: 'Domanda aggiunta con successo!',
        addQuestionError: "Errore durante l'aggiunta della domanda.",
        addQuestionRetry: "Errore durante l'aggiunta della domanda. Riprova.",
        editQuestionSuccess: 'Domanda modificata con successo!',
        editQuestionError: 'Errore durante la modifica della domanda.',
        regenerateKeywordsError: 'Errore durante la rigenerazione delle parole chiave.',
        saveKeywordsError: 'Errore durante il salvataggio delle parole chiave.',
        editQuestionRetry: 'Errore durante la modifica della domanda. Riprova.',
        fetchQuestionsError: 'Errore nel recupero delle domande:',
        fetchSubjectsError: 'Errore nel recupero delle materie:',
        fetchArchivesError: 'Errore nel recupero degli archivi:',
        addArchiveError: "Errore durante l'aggiunta dell'archivio:",
        deleteArchiveError: "Errore durante l'eliminazione dell'archivio:",
        addSubjectError: "Errore durante l'aggiunta della materia:",
        editSubjectError: 'Errore durante la modifica della materia:',
        quizSimulationStart: 'Avvio simulazione quiz',
        serverResponseError: 'Errore di risposta dal server:',
        requestError: 'Errore di richiesta:',
        genericError: 'Errore:',
        quizSaveError: 'Errore durante il salvataggio del quiz:',
        choosePdf: 'Seleziona un PDF da importare.',
        importPdfError: "Errore durante l'importazione del PDF:",
        selectCorrectAnswerForAll: 'Seleziona una risposta corretta per tutte le domande chiuse.',
        completeAnswersSuccess: 'Risposte corrette salvate con successo.',
        completeOpenAnswersSuccess: 'Risposte aperte salvate con successo.',
        completeAnswersError: 'Errore durante il salvataggio delle risposte:',
        quizBlockedIncompleteAnswers: (count) => `Ci sono ${count} domande chiuse senza risposta corretta. Completa le risposte prima di avviare il quiz.`,
        startQuizWithIncompleteAnswers: (count) => `Ci sono ${count} domande chiuse senza risposta corretta. Vuoi avviare comunque il quiz? Le domande senza risposta corretta non potranno essere valutate correttamente finché non le completi.`,
        resumeQuizDraft: 'Hai un quiz iniziato e non confermato. Vuoi continuarlo? Premi Annulla per eliminarlo e iniziarne uno nuovo.',
        noQuestionsForQuizFilter: 'Non ci sono domande disponibili con le impostazioni selezionate.',
      },
    },
    account: {
      title: 'Impostazioni Account',
      subtitle: 'Gestisci le informazioni del tuo profilo, la password e la chiusura dell’account.',
      personalInfo: 'Informazioni utente',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      role: 'Ruolo',
      saveInfo: 'Salva informazioni',
      passwordTitle: 'Cambio password',
      currentPassword: 'Password attuale',
      newPassword: 'Nuova password',
      confirmPassword: 'Conferma nuova password',
      updatePassword: 'Aggiorna password',
      dangerTitle: 'Eliminazione account',
      dangerText: 'Eliminando l’account verranno eliminati definitivamente anche materie, domande, quiz svolti e tutte le informazioni collegate al tuo utente.',
      deleteAccount: 'Elimina account',
      confirmDeleteTitle: 'Conferma eliminazione account',
      confirmDeleteText: 'Questa azione è definitiva. Per continuare, inserisci la password attuale e scrivi ELIMINA nel campo di conferma.',
      confirmationLabel: 'Scrivi ELIMINA',
      confirmDelete: 'Elimina definitivamente',
      cancel: 'Annulla',
      profileSaved: 'Informazioni aggiornate con successo.',
      passwordSaved: 'Password aggiornata con successo.',
      accountDeleted: 'Account eliminato con successo.',
      genericError: 'Operazione non riuscita.',
    },
  },
  en: {
    meta: {
      title: 'Quizify | Produce Your Quizzes',
    },
    common: {
      back: 'Back',
    },
    nav: {
      documentation: 'Documentation',
      index: 'Index',
      signIn: 'Sign in',
      dashboard: 'Dashboard',
      calendar: 'Calendar',
      calendarMini: 'C',
      accountSetting: 'Account Setting',
      subjects: 'Archive',
      subjectsMini: 'A',
      quizWip: 'Quiz',
      quizWipMini: 'Q',
      statistics: 'Statistics',
      statisticsMini: 'S',
      scannerWip: 'Scanner',
      scannerWipMini: 'S',
      scannerLive: 'Live Scanner',
      scannerLiveMini: 'L',
      siteSettings: 'Settings',
      siteSettingsMini: 'S',
      toolsWip: 'Tools',
      toolsWipMini: 'T',
      startQuiz: 'Start Quiz',
      startQuizMini: 'Q',
      logout: 'Logout',
    },
    calendarPage: {
      title: 'Calendar',
      subtitle: 'Plan the archives and subjects you want to study in the next days.',
      today: 'Today',
      month: 'Month',
      week: 'Week',
      day: 'Day',
      list: 'List',
      archive: 'Archive',
      subject: 'Subject',
      selectArchive: 'Select archive',
      selectSubject: 'Select subject',
      selectedSubjectProgress: 'Progress for the selected subject, separated by question type.',
      selectSubject: 'Select subject',
      eventType: 'What do you want to add?',
      addEventTitle: 'Add to calendar',
      addEvent: 'Add',
      cancel: 'Cancel',
      close: 'Close',
      remove: 'Remove',
      dayEventsTitle: 'Day events',
      noArchives: 'There are no available archives. Create an archive first.',
      noSubjects: 'This archive does not contain subjects.',
      noEventsForDay: 'There are no events for this day.',
      pastDateBlocked: 'You cannot add events to previous days.',
      archiveBlockedBySubjects: 'One or more subjects from this archive are already scheduled on this day. Remove them before adding the whole archive.',
      subjectBlockedByArchive: 'The whole archive is already scheduled on this day. Remove it before adding a subject from the same archive.',
      archiveAlreadyAdded: 'This archive is already scheduled on this day.',
      subjectAlreadyAdded: 'This subject is already scheduled on this day.',
      archiveAlreadyScheduled: 'This archive is already scheduled on a day that has not passed yet.',
      subjectAlreadyScheduled: 'This subject is already scheduled on a day that has not passed yet.',
      archiveBlockedByActiveSubjects: 'One or more subjects from this archive are already scheduled on a day that has not passed yet. Remove them before adding the whole archive.',
      subjectBlockedByActiveArchive: 'The whole archive is already scheduled on a day that has not passed yet. Remove it before adding a subject from the same archive.',
      moreEvents: (count) => `+${count} events`,
      eventsCount: (count) => `${count} events`,
      sampleEvents: {
        externalLink: 'Open Google',
        allDay: 'All Day Event',
        longEvent: 'Long Event',
        repeating: 'Repeating Event',
        birthday: 'Birthday Party',
        meeting: 'Meeting',
      },
    },
    scannerPage: {
      title: 'Scanner',
      subtitle: 'Take or upload a picture, recognize text, and quickly find the matching question in your database.',
      questionsLoaded: (count) => `${count} available questions`,
      takePhoto: 'Take photo',
      cameraStarting: 'Opening camera...',
      uploadImage: 'Upload image',
      ocrLoading: 'Recognizing text',
      recognizedText: 'Recognized text to search',
      recognizedPlaceholder: 'OCR text will appear here. You can edit it before searching.',
      answerSearch: 'Search text in answers',
      answerSearchPlaceholder: 'Type an answer or part of an answer to distinguish similar questions...',
      searchButton: 'Search',
      resultsTitle: 'Scanner results',
      resultsFound: (count) => `${count} results found`,
      previous: 'Previous',
      next: 'Next',
      archiveFilter: 'Archive',
      subjectFilter: 'Subject',
      allArchives: 'All archives',
      allSubjects: 'All subjects',
      searchAnswers: 'Also search answers',
      questionTypeFilter: 'Question type',
      allQuestionTypes: 'Open and closed',
      onlyClosedQuestions: 'Closed only',
      onlyOpenQuestions: 'Open only',
      addAnswerField: 'Add answer text',
      removeAnswerField: 'Remove this answer text',
      answerSearchNumber: (number) => `Answer text ${number}`,
      additionalAnswerSearchPlaceholder: (number) => `Answer text ${number}...`,
      exactSearch: 'Exact search',
      similaritySearch: 'Similarity search',
      similaritySearchOffHelp: 'Only shows questions containing that text.',
      similaritySearchOnHelp: 'Also shows questions similar to the searched text.',
      openQuestion: 'Open',
      closedQuestion: 'Closed',
      exactMatch: 'Exact',
      currentSearch: 'Active search',
      noCurrentSearch: 'No selected text',
      loadingQuestions: 'Loading questions...',
      emptySearch: 'Take a photo, upload an image, or enter recognized text to search.',
      noResults: 'No results found. Try fixing the text or enabling answer search.',
      noArchiveName: 'No archive assigned',
      questionWithoutText: 'Question without text',
      correct: 'Correct',
      emptyAnswer: 'Empty answer',
      noCorrectAnswer: 'No correct answer saved for this question.',
      showAllAnswers: 'Show all answers',
      hideAnswers: 'Hide answers',
      cameraTitle: 'Take a photo',
      capture: 'Use photo',
      cropTitle: 'Crop image',
      cropHelp: 'Select only the area with the question or useful text. Drag the box and use the corners to resize it.',
      useCrop: 'Use crop',
      useFullImage: 'Use full image',
      close: 'Close',
      errors: {
        generic: 'Error while loading the scanner.',
        invalidImage: 'Invalid image. Upload an image file or take a new photo.',
        emptyText: 'No useful text was recognized in the image.',
        ocrFailed: 'Error while recognizing text.',
        cameraDenied: 'Camera permission denied or camera unavailable.',
      },
    },
    scannerLivePage: {
      title: 'Live Scanner',
      subtitle: 'Point the camera at the screen: Quizify recognizes questions and keeps suggested answers visible while you scroll.',
      archive: 'Archive',
      subject: 'Subject',
      questionType: 'Question type',
      allArchives: 'All archives',
      allSubjects: 'All subjects',
      both: 'Open and closed',
      closed: 'Closed',
      open: 'Open',
      questionsAvailable: (count) => `${count} available questions`,
      start: 'Start Live Scanner',
      starting: 'Preparing OCR...',
      stop: 'Stop',
      live: 'Live',
      analyzing: 'Analyzing',
      reading: 'Reading the screen...',
      pointCamera: 'Clearly frame a question',
      detected: (count) => `${count} tracked questions`,
      summary: 'Detected session',
      noAnswer: 'No correct answer has been saved.',
      errors: {
        camera: 'The camera cannot be used. Check your browser permissions.',
        ocr: 'This frame could not be analyzed. Scanning will continue automatically.',
      },
    },
    statisticsPage: {
      title: 'Statistics',
      subtitle: 'Archive-level overview of study progress, subjects, and results over time.',
      selectArchive: 'Select archive',
      noArchives: 'There are no available archives. Create an archive first.',
      correct: 'Correct',
      wrong: 'Wrong',
      unanswered: 'Unanswered',
      unseen: 'Never seen',
      total: 'Total',
      accuracy: 'Accuracy',
      distributionTitle: 'Archive answer distribution',
      distributionSubtitle: 'Correct, wrong, unanswered, and never seen unique questions.',
      subjectDistributionTitle: 'Subject distribution and progress',
      subjectDistributionSubtitle: 'View answers or the current study pass for the selected subject.',
      accuracyBySubjectTitle: 'Accuracy by subject',
      accuracyBySubjectSubtitle: 'Correct percentage over answered closed questions.',
      noSubjectAccuracy: 'There are no subjects with enough data yet.',
      trendTitle: 'Results over time',
      trendSubtitle: 'Quiz accuracy trend over time.',
      noDistribution: 'There are no studied questions to display yet.',
      noTrend: 'There are no completed quizzes yet to draw the trend.',
      subjectOverviewTitle: 'Subject overview',
      subjectOverviewSubtitle: 'Each bar shows the real question status for that subject.',
      completionBasedOn: 'Completion based on',
      details: 'Details',
      close: 'Close',
      question: 'Question',
      seenCount: 'Seen',
      wrongCount: 'Wrong',
      correctCount: 'Correct',
      skippedCount: 'Skipped',
      questionWithoutText: 'Question without text',
      mostWrongQuestions: 'Most frequently wrong questions',
      mostSeenQuestions: 'Most frequently seen questions',
      unansweredQuestions: 'Seen but unanswered questions',
      unseenQuestions: 'Never seen questions',
      noWrongQuestions: 'There are no wrong questions for this subject yet.',
      noSeenQuestions: 'There are no seen questions for this subject yet.',
      noUnansweredQuestions: 'There are no seen questions left unanswered.',
      noUnseenQuestions: 'There are no never-seen questions in this subject.',
      loadedQuestions: (shown, total) => `${shown}/${total} loaded`,
      loadMore: 'Load more',
      loading: 'Loading...',
      initialCompletion: 'Initial completion',
      progressiveReview: (pass) => `Progressive review ${pass}`,
      completedPassesDerived: 'Complete passes in the current set',
      reviewProgressCount: (completed, total) => `${completed}/${total} questions`,
      reviewNotStarted: 'No questions have been viewed yet.',
      allQuestions: 'All',
      closedQuestions: 'Closed',
      openQuestions: 'Open',
      subjectAnswerDistribution: 'Subject answers',
      studyProgressDistribution: 'Study progress',
      reviewDistribution: (pass) => `Review ${pass} progress`,
      reviewCompleted: 'Completed in this pass',
      reviewRemaining: 'Remaining in this pass',
      sortQuestions: 'Sort questions',
      sortInsertionAsc: 'Insertion: first to last',
      sortInsertionDesc: 'Insertion: last to first',
      sortAlphabeticalAsc: 'Question: A-Z',
      sortAlphabeticalDesc: 'Question: Z-A',
      sortSeenDesc: 'Seen: highest first',
      sortSeenAsc: 'Seen: lowest first',
      sortWrongDesc: 'Wrong: highest first',
      sortWrongAsc: 'Wrong: lowest first',
      sortCorrectDesc: 'Correct: highest first',
      sortCorrectAsc: 'Correct: lowest first',
      sortSkippedDesc: 'Skipped: highest first',
      sortSkippedAsc: 'Skipped: lowest first',
    },
    quizPage: {
      title: 'Quiz',
      subtitle: 'Generate a quiz from a full archive or choose which subjects to include.',
      selectArchive: 'Select archive',
      totalQuestions: (count) => `Quiz total: ${count} questions`,
      availableBySubject: (total, closed, open) => `${total} available (${closed} closed, ${open} open)`,
      subjectQuestionCount: 'Questions for this subject',
      subjectOpenQuestionCount: 'Open questions for this subject',
      noArchives: 'There are no available archives. Create an archive first.',
      noSubjectsInArchive: 'This archive does not contain subjects yet.',
      noQuestionsSelected: 'Select at least one question to start the quiz.',
      startGeneratedQuiz: 'Start quiz',
      selectSubjectsTitle: 'Select subjects to include',
      selectSubjectsHelp: 'Choose which archive subjects should be used in the quiz and set how many questions to take from each one.',
      selectAllSubjects: 'Select all',
      deselectAllSubjects: 'Deselect all',
      resumeQuizTitle: 'Unfinished quiz',
      resumeQuizText: 'You have a quiz that was started but not finished. This can happen if the page is closed, the browser crashes, or the computer shuts down before the final confirmation.',
      continueQuiz: 'Resume quiz',
      startNewQuiz: 'New quiz',
      close: 'Close',
      resumeQuizLoadError: 'Error loading the in-progress quiz.',
    },
    home: {
      tagline: 'Produce your own quizzes and pass any challenges proposed by courses or school/university subjects.',
      developmentWarning: (
        <>
          Quizify is a personal project still under development.<br />
          Some features may not be complete, but you will never be asked to purchase anything.
        </>
      ),
      dashboardDemo: 'Start now',
      githubPrefix: 'STAR US',
      githubSuffix: 'ON GITHUB',
    },
    auth: {
      signInTitle: 'Sign In',
      signInSubtitle: 'Sign in to use Quizify.',
      signUpTitle: 'Sign Up',
      signUpSubtitle: 'Create your Quizify account.',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone No.',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      rememberMe: 'Remember Me',
      forgotPassword: 'Forgot Password?',
      signInButton: 'Sign In',
      signUpButton: 'Sign Up',
      agreeTerms: 'I agree with the terms of use',
      socialPrompt: 'or sign in with other accounts?',
      noAccount: 'Don’t have an account?',
      signUpLink: 'Click here to sign up.',
      alreadyHaveAccount: 'Already have an account?',
      invalidCredentials: 'Invalid credentials.',
      registrationFailed: 'Registration failed. Please try again.',
      registrationDisabledTitle: 'Registrations disabled',
      registrationDisabledMessage: 'New accounts cannot currently be created. Please try again later.',
      responseError: 'Server response error:',
      requestError: 'Request error:',
      genericError: 'Error:',
    },
    language: {
      changeLanguage: 'Change language',
      currentLanguage: 'Current language',
    },
    siteSettingsPage: {
      title: 'Settings',
      subtitle: 'Manage the features that are publicly available on the platform.',
      registrationTitle: 'New user registration',
      registrationEnabledHelp: 'Anyone can open the registration page and create an account.',
      registrationDisabledHelp: 'The page remains available, but the form is locked and no account can be created.',
      disabledWarning: 'When this option is disabled, every new registration is also rejected by the server.',
      enabled: 'Enabled',
      disabled: 'Disabled',
      save: 'Save settings',
      saving: 'Saving...',
      saved: 'Settings saved successfully.',
      loading: 'Loading settings...',
    },
    dashboard: {
      subHeaderTitle: 'Hello Buddies!',
      subHeaderText: "I'm on a mission to help students learn by building exam simulations for FREE.",
      title: 'Quizify Dashboard',
      greeting: (name) => `Hi ${name}, keep working on your quizzes.`,
      selectArchive: 'Select archive',
      manageSubjects: 'Manage archive',
      openCalendar: 'Calendar',
      noArchivesAvailable: 'No archive available',
      noArchivesText: 'Create an archive to view dashboard stats.',
      tips: [
        'Completion measures the questions you answered during completed quizzes.',
        'A subject is ready for quizzes when it contains at least 10 questions.',
      ],
      cards: {
        subjects: 'Subjects',
        subjectsNote: 'Subjects created by you',
        quizAttempts: 'Quizzes taken',
        quizAttemptsNote: 'Completed quiz sessions',
        completedQuestions: 'Completed questions',
        unansweredNote: (count) => `${count} still unanswered`,
        unseenQuestions: 'Unseen questions',
        seenNote: (count) => `${count} already seen in quizzes`,
        totalQuestions: 'Total questions',
        totalQuestionsNote: 'Questions created by you',
        averageCompletion: 'Average completion',
        averageCompletionNote: 'Average across your subjects',
        registeredUsers: 'Registered users',
        newUsersNote: (count) => `${count} new in the last 7 days`,
        platformSubjects: 'Platform subjects',
        platformSubjectsNote: 'Created by all users',
        platformQuestions: 'Platform questions',
        platformQuestionsNote: 'Global total',
      },
      subjectsCompletion: 'Subjects and completion',
      subjectsCompletionSubtitle: 'Progress based on questions seen and answered in completed quizzes.',
      table: {
        subject: 'Subject',
        quizAttempts: 'Quizzes taken',
        questions: 'Questions',
        unseen: 'Unseen',
        completion: 'Completion',
        lastQuiz: 'Last quiz',
      },
      latestQuizzes: 'Latest quizzes',
      latestQuizzesSubtitle: 'Your latest completed or in-progress quiz sessions.',
      showMoreRecentQuizzes: (count) => `Show ${count} more quizzes`,
      hideRecentQuizzes: 'Hide',
      reviewQuiz: 'Review quiz',
      continueQuiz: 'Continue quiz',
      inProgressQuiz: 'In progress',
      noSubjectsTitle: 'You do not have subjects yet',
      noSubjectsText: 'Create an archive, then add your first subject and start adding questions.',
      createSubject: 'Create subject',
      noQuizzesTitle: 'No quizzes taken yet',
      noQuizzesText: 'When you start and finish a quiz, it will appear here.',
      answers: 'answers',
      studyPlanLabel: 'Calendar study plan',
      studyPlanDueDate: 'Due date',
      studyPlanRemaining: 'Questions left',
      studyPlanDailyTarget: 'Daily target',
      studyPlanCurrentPace: 'Current pace',
      studyPlanCompleted: 'Completed',
      studyPlanNoPace: 'There is not enough pace yet to estimate a finish date.',
      studyPlanAhead: (days) => (
        days === 0
          ? 'At this pace, you finish exactly on time.'
          : `At this pace, you finish ${days} days early.`
      ),
      studyPlanLate: (days) => `At this pace, you would finish ${days} days late.`,
      studyPlanSubjects: (subjectsCount, days) => `${subjectsCount} planned subjects - ${days} days available`,
      studyPlanBySubject: 'Daily work by subject',
      studyPlanReviewBySubject: (review) => `Review ${review} by subject`,
      studyPlanSubjectDaily: (answeredToday, count) => `${answeredToday}/${count} today`,
      studyPlanSubjectClosedDaily: (answeredToday, count) => `Closed ${answeredToday}/${count}`,
      studyPlanSubjectOpenDaily: (answeredToday, count) => `Open ${answeredToday}/${count}`,
      studyPlanReviewName: (review) => `Review ${review}`,
      studyPlanReviewAnswers: 'Answers',
      studyPlanReviewSeen: 'Seen',
      studyPlanSubjectReviewProgress: (answered, viewed, total) => (
        `Answered ${answered}/${total} · Seen ${viewed}/${total}`
      ),
      studyPlanReviewFinish: (review, days) => (
        days <= 1
          ? `At this pace, you finish Review ${review} today.`
          : `At this pace, you finish Review ${review} in ${days} days.`
      ),
      studyPlanReviewDailyReached: (done, target) => (
        done > target
          ? `Today's target exceeded: ${done}/${target}.`
          : `Today's target completed: ${done}/${target}.`
      ),
      studyPlanReviewNoPace: (review) => `Answer a few questions to estimate the end of Review ${review}.`,
      studyPlanMoreSubjects: (count) => `+${count} more subjects`,
      studyPlanShowMoreSubjects: (count) => `Show ${count} more subjects`,
      studyPlanHideSubjects: 'Hide',
      studyPlanReviewStatus: (review, answered, total) => `Review ${review}: answered ${answered}/${total}`,
      studyPlanViewStatus: (review, viewed, total) => `Seen ${viewed}/${total}`,
      newUsers: 'New users',
      recentRegistrations: 'Latest registrations.',
      noActivity: 'No activity',
      noDescription: 'No description',
      loading: 'Loading dashboard...',
      invalidSession: 'Invalid session. Please sign in again.',
      loadError: 'Unable to load dashboard data.',
    },
    toolsPage: {
      title: 'Tools',
      subtitle: 'Working utilities for PDFs, archives, and subjects.',
      openTool: 'Open',
      backToTools: 'Back to tools',
      pdfRepair: {
        title: 'Repair PDF search',
        subtitle: 'Fixes internal encoding when possible; otherwise keeps the original pages and adds searchable text.',
        fileLabel: 'PDF to analyze',
        choosePdf: 'Select a PDF.',
        analyze: 'Repair search',
        analyzing: 'Analyzing...',
        reset: 'Change PDF',
        resultTitle: 'Repaired PDF preview',
        emptyResult: 'Upload a PDF to prepare the searchable preview.',
        mode: 'Extraction',
        repairMethod: 'PDF repair',
        repairMethods: {
          'native-unicode': 'Native',
          'coordinate-text-repair': 'Text coordinates',
          'fallback-invisible-layer': 'Invisible layer',
          'text-only-fallback': 'Text PDF',
        },
        characters: 'Characters',
        questions: 'Questions',
        artifacts: 'Noisy chars',
        readyTitle: 'Ready to download',
        reviewNeeded: 'Needs review',
        cleanResult: 'No obvious issue in the recognized text.',
        copy: 'Copy text',
        copied: 'Text copied to clipboard.',
        copyError: 'Unable to copy the text automatically.',
        download: 'Download PDF',
        openPdf: 'Open PDF',
        openPdfError: 'Unable to open the PDF in a new tab. Use Download PDF.',
        downloading: 'Preparing download...',
        preparingPdf: 'Preparing PDF...',
        previewUnavailable: 'PDF preview unavailable.',
        downloaded: 'Searchable PDF created while keeping the original document.',
        downloadedWithMethod: (method) => `Searchable PDF created with: ${method}.`,
        downloadError: 'Error while creating the searchable PDF.',
        searchLabel: 'Check recognized text',
        searchPlaceholder: 'Search a word or phrase',
        pdfSearchPlaceholder: 'Search in PDF',
        pdfSearchAction: 'Search',
        pdfSearching: 'Searching...',
        pdfSearchMatches: (count) => `${count} matches highlighted.`,
        pdfSearchPrevious: 'Previous result',
        pdfSearchNext: 'Next result',
        pdfSearchResultCount: (current, total) => `${current || 0}/${total || 0}`,
        pdfSearchNoResults: '0 results',
        pdfPreviewLoading: 'Loading preview...',
        pdfPageCount: (current, total) => `Page ${current || 1}/${total || '-'}`,
        previewRows: (shown, total) => `First ${shown} rows of ${total}.`,
        previewMatches: (shown, total) => `${shown} matching rows of ${total}.`,
        scrollForMoreRecognizedText: 'Scroll to load more rows.',
        noSearchResults: 'No line found.',
        candidate: 'Extraction',
        diagnosticsTitle: 'Extraction details',
        recognizedTextTitle: 'Recognized text',
        selected: 'used',
        error: 'Error while repairing the PDF.',
      },
      subjectCompare: {
        title: 'Compare subjects',
        subtitle: 'Compare two subjects and show different questions, answers, and correct options.',
        baseArchive: 'Main archive',
        baseSubject: 'Main subject',
        compareArchive: 'Archive to compare',
        compareSubject: 'Subject to compare',
        selectArchive: 'Select archive',
        selectSubject: 'Select subject',
        chooseSubjects: 'Select two different subjects.',
        compare: 'Compare',
        comparing: 'Comparing...',
        resultTitle: 'Found differences',
        emptyResult: 'Select two subjects and start the comparison.',
        matched: 'Matched',
        different: 'Different',
        onlyBase: 'Only main',
        onlyCompare: 'Only compared',
        answers: 'Answers',
        reasons: {
          type: 'Different question type',
          'correct-answer': 'Different correct answer',
          answers: 'Different options',
        },
        differentQuestionsTitle: (count) => `Different answers (${count})`,
        onlyBaseTitle: (count) => `Only in the main subject (${count})`,
        onlyCompareTitle: (count) => `Only in the compared subject (${count})`,
        duplicateWarningsTitle: (count) => `Duplicates to check (${count})`,
        duplicateWarning: (baseCount, compareCount, questionText) => `Different duplicate count: ${baseCount} in main, ${compareCount} in compared. ${questionText}`,
        noDifferentQuestions: 'No differences in matched questions.',
        noOnlyBase: 'No question exists only in the main subject.',
        noOnlyCompare: 'No question exists only in the compared subject.',
        error: 'Error while comparing subjects.',
      },
    },
    subjectsPage: {
      archives: 'Archives',
      archive: 'Archive',
      addArchive: 'Add archive',
      archiveName: 'Archive name',
      backToArchives: 'Back to archives',
      noArchives: 'There are no archives. Add a new archive.',
      emptyArchiveAlertPrefix: "You haven't added any archives yet.",
      emptyArchiveAlertAction: 'Add archive',
      emptyArchiveAlertSuffix: 'to get started.',
      totalSubjects: 'Total subjects',
      emptyAlertPrefix: "It looks like you haven't added any subjects yet.",
      emptyAlertAction: 'Add Subject',
      emptyAlertSuffix: 'to get started.',
      addSubject: 'Add Subject',
      subjectName: 'Subject Name',
      add: 'Add',
      close: 'Close',
      edit: 'Edit',
      start: 'Start',
      abort: 'Abort',
      yesDelete: 'Yes, delete',
      deleting: 'Deleting...',
      totalQuestions: 'Total Questions',
      closedQuestions: 'Closed Questions',
      openQuestions: 'Open Questions',
      missingAnswersLabel: 'Missing correct answer',
      missingOpenAnswersLabel: 'Open answers to complete',
      missingAnswersSummary: (closed, open) => {
        if (closed > 0 && open > 0) {
          return `Closed/Open without a correct answer: ${closed}/${open}`;
        }

        if (closed > 0) {
          return `Closed without a correct answer: ${closed}`;
        }

        return `Open without a correct answer: ${open}`;
      },
      noQuestionsButtonTitle: 'No questions available',
      missingAnswersButtonTitle: (count) => `${count} questions without a correct answer`,
      missingOpenAnswersButtonTitle: (count) => `${count} open answers to complete`,
      noSubjects: 'There are no subjects. Add a new subject.',
      settingQuiz: 'Setting Quiz',
      numberAllQuestions: 'N. questions',
      timer: 'Timer:',
      timerPlaceholder: 'Hours : Minutes',
      quizType: 'Quiz Type',
      closed: 'Closed',
      open: 'Open',
      closedQuestion: 'Closed',
      openQuestion: 'Open',
      both: 'Closed & Open',
      numberOpenQuestions: 'N. open questions',
      availableQuestions: (count) => `${count} available with the current quiz type and filter`,
      closedQuestionsWillBe: (count) => `${count} closed questions in the quiz`,
      availableOpenQuestions: (count) => `${count} open questions available with the current filter`,
      questionOrder: 'Question order',
      insertedOrder: 'Insertion order',
      randomOrder: 'Random',
      answerOrder: 'Answer order',
      answerInsertedOrder: 'Original order',
      answerRandomOrder: 'Random',
      correctAnswerFirst: 'Correct answer first',
      showKeywords: 'Show keywords',
      questionFilter: 'Question filter',
      onlyUnseenQuestions: 'Only never seen questions',
      onlySeenQuestions: 'Only already seen questions',
      allSeenAndUnseenQuestions: 'All (seen and unseen)',
      progressiveReview: 'Progressive review',
      automaticOpenAnswers: 'Automatically show the answer to open questions',
      filterQuestionCount: (label, count) => `${label} (${count})`,
      addQuestionAnswers: 'Add Question & Answers',
      editQuestionAnswers: 'Edit Question & Answers',
      question: 'Question:',
      questionAnswerType: 'Question & Answer Type:',
      single: 'Single',
      multiple: 'Multiple',
      correctAnswer: 'Correct Answer',
      answer: (index) => `Answer ${index}`,
      questions: 'Questions',
      previewQuestion: 'Preview and browse questions',
      questionPreviewTitle: 'Question preview',
      questionListPreviewTitle: 'Review filtered list',
      emptyQuestionAnswer: 'Empty answer',
      noFilteredQuestionsToPreview: 'No questions to preview with the current filter.',
      questionAnswers: 'Question & Answers',
      importFromPdf: 'Import from PDF',
      importQuestionsFromPdf: 'Import questions from PDF',
      importAllFromPdf: 'Import subjects from PDF',
      importAllFromPdfTitle: 'Full PDF import',
      importAllFromPdfText: 'Upload a PDF to automatically create subjects, questions, and answers. This feature will be implemented in the next step.',
      ecampusImportText: 'Upload the e-Campus question bank PDF to automatically create the subject, questions, and answers. It also detects answers marked on the answer placeholder.',
      mininternoImportText: 'Upload the Mininterno question bank PDF to automatically create every subject found in the file, including questions, answers, and the correct answer. If a question references a passage, the passage text is linked to that question.',
      importMode: 'Import type',
      backToAddSubject: 'Back to add',
      questionBankType: 'Question bank type',
      ecampusQuestionBank: 'e-Campus question bank',
      ecampusFullImport: 'e-Campus question bank',
      mininternoFullImport: 'Mininterno exam',
      pdfFile: 'Question bank PDF file',
      fullPdfFile: 'Full PDF file',
      featureComingSoon: 'Feature not active yet',
      importPdf: 'Import PDF',
      importing: 'Importing...',
      importPreloaderTitle: 'Import in progress',
      importPreloaderMessage: 'Do not close this page or leave the modal until the import is complete.',
      importPreloaderHint: 'This can take a few minutes if the PDF contains many questions or long texts.',
      importReport: 'Import report',
      expectedQuestions: (open, closed, total) => `Declared in PDF: ${open ?? '-'} open, ${closed ?? '-'} closed${total ? `, ${total} total` : ''}.`,
      contentQuestionMarkers: (count) => `Numbered questions found in PDF content: ${count ?? 0}.`,
      detectedQuestions: (open, closed, total) => `Detected by parser: ${open ?? 0} open, ${closed ?? 0} closed, ${total ?? 0} total.`,
      importedQuestions: (open, closed, total) => `Imported into database: ${open ?? 0} open, ${closed ?? 0} closed, ${total ?? 0} total.`,
      detectedAnsweredQuestions: (summary = {}) => `Answered in PDF: ${summary.closedWithCorrect ?? 0}/${summary.closed ?? 0} closed with correct answer, ${summary.openWithAnswer ?? 0}/${summary.open ?? 0} completed open.`,
      insertedAnsweredQuestions: (summary = {}) => `Newly inserted: ${summary.closedWithCorrect ?? 0} closed with correct answer, ${summary.closedWithoutCorrect ?? 0} closed without correct answer, ${summary.openWithAnswer ?? 0} open with answer, ${summary.openWithoutAnswer ?? 0} empty open.`,
      updatedAnsweredQuestions: (summary = {}) => `Updated existing: ${summary.closedCorrectAnswers ?? 0} closed answers, ${summary.openAnswers ?? 0} open answers.`,
      finalAnsweredQuestions: (summary = {}) => `Subject after import: ${summary.closedWithCorrect ?? 0}/${summary.closed ?? 0} closed with correct answer, ${summary.openWithAnswer ?? 0}/${summary.open ?? 0} open with answer.`,
      importedSubjects: (count) => `Imported or updated subjects: ${count}.`,
      detectedPassages: (count) => `Detected passages: ${count}.`,
      skippedDuplicates: (count) => `Skipped duplicates: ${count}.`,
      updatedDuplicateAnswers: (count) => `Answers updated on existing questions: ${count}.`,
      updatedDuplicateCorrectAnswers: (count) => `Closed answers updated on existing questions: ${count}.`,
      updatedDuplicateOpenAnswers: (count) => `Open answers updated on existing questions: ${count}.`,
      updatedDuplicateKeywordHints: (count) => `Keywords updated on existing questions: ${count}.`,
      keywordHintsSavedDuringImport: (created, updated) => `Keywords saved: ${created ?? 0} new${updated ? `, ${updated} updated` : ''}.`,
      keywordHintsImportSources: (fromPdf, generated) => `${fromPdf ?? 0} from PDF, ${generated ?? 0} automatically generated.`,
      duplicateDetailsTitle: 'Duplicate details',
      duplicateDetail: (detailOrPdfQuestionNumber, existingQuestionNumber) => {
        const detail = typeof detailOrPdfQuestionNumber === 'object'
          ? detailOrPdfQuestionNumber
          : { pdfQuestionNumber: detailOrPdfQuestionNumber, existingQuestionNumber };
        const subjectPrefix = detail.subjectName ? `Subject: ${detail.subjectName} - ` : '';

        return `${subjectPrefix}App question #${detail.existingQuestionNumber}: duplicated with PDF question #${detail.pdfQuestionNumber}.`;
      },
      missingCorrectAnswers: (count) => `Closed questions without a correct answer: ${count}.`,
      missingOpenAnswers: (count) => `Open questions without an answer: ${count}.`,
      importWarningsTitle: 'Import warnings',
      parserSignalsSummary: (signals = {}) => {
        const otherParts = [
          signals.unnumberedOpenQuestions ? `${signals.unnumberedOpenQuestions} unnumbered open questions` : '',
          signals.splitQuestionMarkers ? `${signals.splitQuestionMarkers} rebuilt question numbers` : '',
          signals.ambiguousClosedAnswers ? `${signals.ambiguousClosedAnswers} ambiguous` : '',
        ].filter(Boolean);

        return otherParts.length ? `Other signals: ${otherParts.join(', ')}.` : '';
      },
      keywordHighlightSignalsSummary: (signals = {}) => (
        signals.keywordHintsFromHighlight
          ? `PDF keywords recognized: ${signals.keywordHintsFromHighlight} answers with keywords. Marks used: ${signals.keywordPdfHighlightMarks || 0} highlights, ${signals.keywordPdfUnderlineMarks || 0} underlines.`
          : ''
      ),
      completeQuestionsWithoutAnswers: 'Complete questions without answers',
      completeClosedAnswers: 'Complete closed answers',
      completeOpenQuestionsWithoutAnswers: 'Complete open answers',
      regenerateMissingKeywords: 'Regenerate missing keywords',
      regenerateMissingKeywordsShort: (count) => `Missing keywords (${count})`,
      unsavedKeywordsShort: (count) => `Keywords to save (${count})`,
      regeneratingKeywords: 'Regenerating keywords...',
      savingKeywords: 'Saving...',
      saveAvailableKeywords: 'Save available',
      keywordRegenerationSummary: (report = {}) => (
        `Updated keywords: ${report.updated || 0}. Already present: ${report.skippedExisting || 0}. Manually excluded: ${report.skippedDisabled || 0}. No automatic suggestion: ${report.skippedUnavailable || 0}.`
      ),
      keywordSaveSummary: (report = {}) => (
        `Saved keywords: ${report.updated || 0}. Already present: ${report.skippedExisting || 0}. Manually excluded: ${report.skippedDisabled || 0}. Unavailable: ${report.skippedUnavailable || 0}.`
      ),
      keywordToolsTitle: 'Closed question keywords',
      keywordToolsMissingTitle: (count) => `Without keywords (${count})`,
      keywordToolsUnsavedTitle: (count) => `Keywords to save (${count})`,
      keywordToolsMixedTitle: (missingCount, unsavedCount) => `Keywords to fix (${unsavedCount} to save, ${missingCount} without)`,
      keywordToolsMixedShort: (missingCount, unsavedCount) => `Keywords: ${unsavedCount} to save, ${missingCount} without`,
      keywordToolsMissingDescription: (count) => `${count} closed questions have no saved keyword and no automatic suggestion. Open them from the table and write one manually.`,
      keywordToolsUnsavedDescription: (count) => `${count} closed questions do not have a saved keyword, but have an automatic keyword ready. You can save all of them or show them in the table.`,
      keywordToolsMixedDescription: (missingCount, unsavedCount) => `${unsavedCount} questions do not have a saved keyword, but have an automatic keyword ready. ${missingCount} have no automatic suggestion: show them and write one manually.`,
      keywordsWithoutSavedHint: (count) => `Questions without a saved keyword: ${count}.`,
      keywordsWithAutomaticHint: (count) => `With an available automatic suggestion: ${count}.`,
      keywordsActuallyMissing: (count) => `Without any effective keyword: ${count}.`,
      noMissingEffectiveKeywords: 'All closed questions have a saved or automatic keyword.',
      showMissingKeywordQuestions: 'Show without keywords',
      showUnsavedKeywordQuestions: 'Show to save',
      showKeywordToolQuestions: 'Show',
      showAllQuestions: 'Show all',
      copyKeywordPrompt: 'Copy prompt',
      copyMissingKeywordPrompt: 'Copy missing prompt',
      copyUnsavedKeywordPrompt: 'Copy to-save prompt',
      keywordPromptCopied: 'Prompt copied to clipboard.',
      keywordPromptCopyError: 'Unable to copy the prompt automatically.',
      keywordPromptEmpty: 'No questions to copy.',
      missingKeywordFilterActive: (count) => `Filter: without keywords (${count}).`,
      unsavedKeywordFilterActive: (count) => `Filter: unsaved keywords (${count}).`,
      completeMissingAnswersTitle: 'Complete missing correct answers',
      completeMissingOpenAnswersTitle: 'Complete open answers',
      completeMissingAnswersText: 'Select the correct answer for each closed question. Open questions can stay empty.',
      completeMissingOpenAnswersText: 'Write the reference answer for open questions. You can leave it empty and move to the next one.',
      noAnswersToComplete: 'There are no closed questions to complete.',
      noOpenAnswersToComplete: 'There are no open answers to complete.',
      correctAnswersSelected: (completed, total) => `${completed}/${total} completed`,
      openAnswersFilled: (completed, total) => `${completed}/${total} filled`,
      saveAnswers: 'Save answers',
      unsavedCompleteAnswersTitle: 'You have unsaved changes',
      unsavedCompleteAnswersText: 'If you close without saving, you will lose all progress made so far. Save to keep the answers you selected.',
      saveAndClose: 'Save and close',
      closeWithoutSaving: 'Close without saving',
      keepEditing: 'Cancel',
      editSubject: 'Edit Subject',
      confirmDeletion: 'Confirm Deletion',
      confirmArchiveDeletion: 'Confirm archive deletion',
      deleteArchiveWarning: (name) => (
        <>
          You are about to delete the archive <strong>{name}</strong>. All subjects, questions, answers, and associated data inside it will be deleted too.
        </>
      ),
      deleteArchiveConfirmationLabel: 'Type DELETE to confirm',
      deleteArchiveConfirmationPlaceholder: 'DELETE',
      deleteSubjectConfirm: (name) => <>Are you sure you want to delete the subject named <strong>{name}</strong>?</>,
      deleteQuestionConfirm: (question) => (
        <>
          Are you sure you want to delete the question below?<br />
          <strong>{question}</strong>
        </>
      ),
      table: {
        question: 'Question',
        answers: 'Answers',
        correct: 'Correct',
        actions: 'Actions',
        search: 'Search:',
        lengthMenu: 'Show _MENU_ rows',
        info: 'Showing _START_ to _END_ of _TOTAL_ questions',
        infoEmpty: 'No questions available',
        zeroRecords: 'No matching questions found',
        emptyTable: 'No questions available',
        paginatePrevious: 'Previous',
        paginateNext: 'Next',
        typeFilterLabel: 'Type',
        typeFilterAll: 'All',
        typeFilterClosed: 'Closed',
        typeFilterOpen: 'Open',
      },
      quizSimulation: 'Quiz Simulation',
      questionProgress: (current, total) => `Question ${current} of ${total}`,
      enterYourAnswer: 'Enter your answer:',
      timeLeft: 'Time left:',
      previous: 'Previous',
      next: 'Next',
      endQuiz: 'End quiz',
      endQuizConfirmTitle: 'End the quiz?',
      endQuizConfirmText: 'Are you sure you want to end the quiz? After confirmation, the result will be calculated.',
      unansweredQuestionsWarning: (count) => (
        count === 1
          ? 'There is 1 unanswered question.'
          : `There are ${count} unanswered questions.`
      ),
      confirmEndQuiz: 'Yes, end quiz',
      goBack: 'Go back',
      saving: 'Saving...',
      openAnswerPlaceholder: 'Write your answer',
      readPassage: (number) => `Read passage n.${number}`,
      passageTitle: (number) => `Passage n.${number}`,
      quizCompletedWithIcon: '🎉 Quiz completed',
      quizCompleted: 'Quiz completed',
      calculatedScore: 'Calculated score',
      timeSummary: (time) => `Time: ${time}`,
      correctAnswersSummary: (count) => `✅ Correct: ${count}`,
      wrongAnswersSummary: (count) => `❌ Wrong: ${count}`,
      openQuestionsSummary: (count) => `📝 Open questions: ${count}`,
      mixedQuizOpenNote: 'Open-answer questions are not included in the automatic score and require manual evaluation. Each open question includes a reference answer for comparison.',
      openOnlyQuizNote: 'This quiz contains only open-answer questions. Answers require manual evaluation and no automatic score is available. Each question includes a reference answer for comparison.',
      reviewQuiz: 'Review quiz',
      result: 'Result',
      yourAnswer: 'Your answer',
      referenceAnswer: 'Reference answer / description',
      automaticReferenceAnswer: 'Answer shown automatically',
      explanation: 'Explanation',
      manualReviewBadge: 'Manual review required',
      findKeyword: 'Find keyword',
      keywordContext: 'Context',
      keywordDifference: 'Difference',
      keywordLabel: 'Keyword',
      keywordPlaceholder: '',
      saveKeyword: 'Save keyword',
      updateKeyword: 'Update keyword',
      regenerateKeyword: 'Regenerate',
      keywordHighlightToggle: 'Highlight',
      keywordSaved: 'Keyword saved.',
      keywordSaveError: 'Error while saving the keyword.',
      keywordTooltipTitle: 'Suggested format',
      keywordTooltipContext: 'Optional: a topic near the difference, useful only as a note.',
      keywordTooltipDifference: 'Words, acronyms, numbers, or phrases that appear in the correct answer and not in the wrong alternatives.',
      keywordTooltipFormat: 'Recommended format: Difference: word, short phrase. Regenerate prioritizes parentheses, quotes, acronyms, numbers, and the difference from the most similar wrong answer. If “Highlight” is on, only differences present in a single alternative are marked.',
      noKeywordFound: 'No automatic suggestion available. You can select or write it manually.',
      noAnswerGiven: 'No answer given',
      noReferenceAnswer: 'No reference answer available.',
      validation: {
        noCorrectAnswer: 'Error: no correct answer selected',
        closedNeedsTwoAnswers: 'Closed questions must have at least two answers.',
        selectCorrectAnswer: 'You must select at least one correct answer.',
        addQuestionSuccess: 'Question added successfully!',
        addQuestionError: 'Error while adding the question.',
        addQuestionRetry: 'Error while adding the question. Please try again.',
        editQuestionSuccess: 'Question updated successfully!',
        editQuestionError: 'Error while editing the question.',
        regenerateKeywordsError: 'Error while regenerating keywords.',
        saveKeywordsError: 'Error while saving keywords.',
        editQuestionRetry: 'Error while editing the question. Please try again.',
        fetchQuestionsError: 'Error fetching questions:',
        fetchSubjectsError: 'Error fetching subjects:',
        fetchArchivesError: 'Error fetching archives:',
        addArchiveError: 'Error while adding the archive:',
        deleteArchiveError: 'Error while deleting the archive:',
        addSubjectError: 'Error while adding the subject:',
        editSubjectError: 'Error while editing the subject:',
        quizSimulationStart: 'Starting quiz simulation',
        serverResponseError: 'Server response error:',
        requestError: 'Request error:',
        genericError: 'Error:',
        quizSaveError: 'Error while saving the quiz:',
        choosePdf: 'Select a PDF to import.',
        importPdfError: 'Error while importing the PDF:',
        selectCorrectAnswerForAll: 'Select a correct answer for every closed question.',
        completeAnswersSuccess: 'Correct answers saved successfully.',
        completeOpenAnswersSuccess: 'Open answers saved successfully.',
        completeAnswersError: 'Error while saving answers:',
        quizBlockedIncompleteAnswers: (count) => `There are ${count} closed questions without a correct answer. Complete them before starting the quiz.`,
        startQuizWithIncompleteAnswers: (count) => `There are ${count} closed questions without a correct answer. Do you want to start the quiz anyway? Questions without a correct answer cannot be graded correctly until you complete them.`,
        resumeQuizDraft: 'You have a quiz started but not confirmed. Do you want to continue it? Press Cancel to delete it and start a new one.',
        noQuestionsForQuizFilter: 'There are no questions available with the selected settings.',
      },
    },
    account: {
      title: 'Account Settings',
      subtitle: 'Manage your profile information, password, and account closure.',
      personalInfo: 'User information',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      role: 'Role',
      saveInfo: 'Save information',
      passwordTitle: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm new password',
      updatePassword: 'Update password',
      dangerTitle: 'Delete account',
      dangerText: 'Deleting your account will permanently delete subjects, questions, completed quizzes, and all information linked to your user.',
      deleteAccount: 'Delete account',
      confirmDeleteTitle: 'Confirm account deletion',
      confirmDeleteText: 'This action is permanent. To continue, enter your current password and type DELETE in the confirmation field.',
      confirmationLabel: 'Type DELETE',
      confirmDelete: 'Delete permanently',
      cancel: 'Cancel',
      profileSaved: 'Information updated successfully.',
      passwordSaved: 'Password updated successfully.',
      accountDeleted: 'Account deleted successfully.',
      genericError: 'Operation failed.',
    },
  },
};

const defaultLanguage = 'en';
const storageKey = 'quizify-language';
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem(storageKey);
    return languages.some((item) => item.code === savedLanguage) ? savedLanguage : defaultLanguage;
  });

  useEffect(() => {
    localStorage.setItem(storageKey, language);
    document.documentElement.lang = language;
    document.title = translations[language].meta.title;
  }, [language]);

  const value = useMemo(() => {
    const currentLanguage = languages.find((item) => item.code === language) || languages[0];

    return {
      language,
      languages,
      currentLanguage,
      setLanguage,
      t: translations[language],
    };
  }, [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }

  return context;
};
